import {
  Box,
  Chip,
  FormControl,
  Input,
  InputLabel,
  Typography,
} from "@mui/material";
import { red } from "@mui/material/colors";
import PropTypes from "prop-types";
import React from "react";

export default function TrackingNumberFormField(props) {
  const {
    value,
    onChangeTrackingNumber,
    trackingNumberIds,
    isShowDupeTrackingNum,
    onRemoveTrackingNumberId,
    disabled,
  } = props;
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Box
        sx={{
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        Tracking Numbers
      </Box>
      <Box
        sx={{
          marginBottom: "16px",
          border: "1px solid #c4c4c4",
          borderRadius: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "0 12px",
            borderBottom: "1px solid #c4c4c4",
          }}
        >
          <FormControl
            fullWidth
            variant="standard"
            sx={{
              borderBottom: "none",
              "& > .MuiIput-root:hover:not(.Mui-disabled)": {
                borderBottom: "none !important",
              },
              "& > .MuiInput-root::before": {
                borderBottom: "none !important",
              },
              "& > .MuiInput-root::after": {
                borderBottom: "none !important",
              },
            }}
            size="small"
            disabled={disabled}
          >
            <InputLabel htmlFor="standard-adornment-amount">
              Tracking #
            </InputLabel>
            <Input
              onKeyUp={onChangeTrackingNumber}
              onChange={onChangeTrackingNumber}
              value={value}
              name="trackingNumber"
              fullWidth
            />
          </FormControl>
        </Box>
        <Box
          sx={{
            padding: "12px",
            height: "auto",
            maxHeight: 1000,
            overflowY: "auto",
            position: "relative",
            paddingTop: "30px",
          }}
        >
          {isShowDupeTrackingNum && (
            <Box
              sx={{
                position: "absolute",
                margin: 0,
                top: 0,
                fontSize: "14px",
                width: "100%",
                left: 0,
                background: red[300],
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="body2" sx={{ margin: "6px 10px" }}>
                Tracking number has already been added
              </Typography>
            </Box>
          )}
          {!trackingNumberIds.length ? (
            <Typography
              variant="body2"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              No tracking number added
            </Typography>
          ) : (
            trackingNumberIds.map((trackingId) => (
              <Chip
                key={trackingId}
                label={trackingId}
                color="primary"
                variant="outlined"
                onDelete={onRemoveTrackingNumberId(trackingId)}
                sx={{
                  margin: "0 6px 10px 0",
                  fontFamily: "monospace",
                  fontSize: "14px",
                  userSelect: "auto",
                }}
                disabled={disabled}
              />
            ))
          )}
        </Box>
      </Box>
    </Box>
  );
}

TrackingNumberFormField.propTypes = {
  value: PropTypes.string,
  onChangeTrackingNumber: PropTypes.func.isRequired,
  trackingNumberIds: PropTypes.arrayOf(PropTypes.string),
  isShowDupeTrackingNum: PropTypes.bool.isRequired,
  onRemoveTrackingNumberId: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

TrackingNumberFormField.defaultProps = {
  value: "",
  trackingNumberIds: [],
  disabled: false,
};
